(function () {
  'use strict';

  function initRecoveryBundle(section) {
    if (!section || section.dataset.recoveryInitialized === 'true') {
      return;
    }

    section.dataset.recoveryInitialized = 'true';


    /* =====================================================
       ELEMENTS
    ===================================================== */

    const button = section.querySelector('[data-add-to-cart]');
    const errorElement = section.querySelector('[data-cart-error]');

    const mainImage = section.querySelector('[data-main-image]');

    const thumbnails = section.querySelectorAll('[data-thumbnail]');
    const previousButton = section.querySelector('[data-thumbnail-prev]');
    const nextButton = section.querySelector('[data-thumbnail-next]');
    const thumbnailTrack = section.querySelector('[data-thumbnail-track]');


    /* =====================================================
       PRODUCT / VARIANT
    ===================================================== */

    const variantId =
      button &&
      button.dataset.variantId
        ? Number(button.dataset.variantId)
        : null;


    /* =====================================================
       THUMBNAIL GALLERY
    ===================================================== */

    function changeMainImage(thumbnail) {
      if (!mainImage || !thumbnail) {
        return;
      }

      const newSrc = thumbnail.dataset.imageSrc;
      const newSrcset = thumbnail.dataset.imageSrcset;
      const newAlt = thumbnail.dataset.imageAlt || 'Product image';

      if (!newSrc) {
        return;
      }

      mainImage.classList.add('is-changing');

      const preloadImage = new Image();

      preloadImage.onload = function () {
        mainImage.src = newSrc;

        if (newSrcset) {
          mainImage.srcset = newSrcset;
        }

        mainImage.alt = newAlt;

        window.requestAnimationFrame(function () {
          mainImage.classList.remove('is-changing');
        });
      };

      preloadImage.onerror = function () {
        mainImage.classList.remove('is-changing');
      };

      preloadImage.src = newSrc;

      thumbnails.forEach(function (item) {
        item.classList.remove('is-active');
      });

      thumbnail.classList.add('is-active');
    }


    thumbnails.forEach(function (thumbnail) {
      thumbnail.addEventListener('click', function () {
        changeMainImage(thumbnail);
      });
    });

    /* =====================================================
      MOBILE MAIN IMAGE ARROWS
    ===================================================== */

    const mainImagePreviousButton =
      section.querySelector('[data-main-image-prev]');

    const mainImageNextButton =
      section.querySelector('[data-main-image-next]');


    function getActiveThumbnailIndex() {

      let activeIndex = 0;

      thumbnails.forEach(function (thumbnail, index) {

        if (
          thumbnail.classList.contains('is-active')
        ) {
          activeIndex = index;
        }

      });

      return activeIndex;
    }


    function changeImageByIndex(index) {

      if (!thumbnails.length) {
        return;
      }

      /*
      * Loop back to last image
      */
      if (index < 0) {
        index = thumbnails.length - 1;
      }

      /*
      * Loop back to first image
      */
      if (index >= thumbnails.length) {
        index = 0;
      }

      const thumbnail = thumbnails[index];

      if (!thumbnail) {
        return;
      }

      changeMainImage(thumbnail);

    }


    /* =====================================================
      PREVIOUS IMAGE
    ===================================================== */

    if (mainImagePreviousButton) {

      mainImagePreviousButton.addEventListener(
        'click',
        function (event) {

          event.preventDefault();
          event.stopPropagation();

          const currentIndex =
            getActiveThumbnailIndex();

          changeImageByIndex(
            currentIndex - 1
          );

        }
      );

    }


    /* =====================================================
      NEXT IMAGE
    ===================================================== */

    if (mainImageNextButton) {

      mainImageNextButton.addEventListener(
        'click',
        function (event) {

          event.preventDefault();
          event.stopPropagation();

          const currentIndex =
            getActiveThumbnailIndex();

          changeImageByIndex(
            currentIndex + 1
          );

        }
      );

    }


    /* =====================================================
       THUMBNAIL ARROWS
    ===================================================== */

    function scrollThumbnails(direction) {
      if (!thumbnailTrack) {
        return;
      }

      const amount = Math.max(
        thumbnailTrack.clientWidth * 0.75,
        150
      );

      thumbnailTrack.scrollBy({
        left: direction * amount,
        behavior: 'smooth'
      });
    }


    if (previousButton) {
      previousButton.addEventListener('click', function () {
        scrollThumbnails(-1);
      });
    }


    if (nextButton) {
      nextButton.addEventListener('click', function () {
        scrollThumbnails(1);
      });
    }


    /* =====================================================
       THUMBNAIL MOUSE WHEEL
       NEW FUNCTIONALITY
    ===================================================== */

    if (thumbnailTrack) {

      thumbnailTrack.addEventListener(
        'wheel',
        function (event) {

          /*
           * Convert vertical mouse wheel movement
           * into horizontal thumbnail scrolling.
           *
           * If the user is already using horizontal
           * trackpad scrolling, we don't interfere.
           */

          if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) {

            event.preventDefault();

            thumbnailTrack.scrollLeft += event.deltaY;

          }

        },
        {
          passive: false
        }
      );

    }


    /* =====================================================
       THUMBNAIL MOUSE DRAG / SWIPE
       NEW FUNCTIONALITY
    ===================================================== */

    if (thumbnailTrack) {

      let isDragging = false;
      let startX = 0;
      let startScrollLeft = 0;
      let hasDragged = false;


      /*
       * Start dragging
       */

      thumbnailTrack.addEventListener(
        'mousedown',
        function (event) {

          /*
           * Only left mouse button.
           */

          if (event.button !== 0) {
            return;
          }

          isDragging = true;
          hasDragged = false;

          startX = event.pageX;
          startScrollLeft = thumbnailTrack.scrollLeft;

          thumbnailTrack.classList.add('is-dragging');

        }
      );


      /*
       * Move while dragging
       */

      thumbnailTrack.addEventListener(
        'mousemove',
        function (event) {

          if (!isDragging) {
            return;
          }

          const distance = event.pageX - startX;


          /*
           * Small movement is still treated as
           * a normal click.
           *
           * This protects existing thumbnail
           * click functionality.
           */

          if (Math.abs(distance) > 5) {
            hasDragged = true;
          }


          thumbnailTrack.scrollLeft =
            startScrollLeft - distance;

        }
      );


      /*
       * Stop dragging
       */

      function stopThumbnailDrag() {

        if (!isDragging) {
          return;
        }

        isDragging = false;

        thumbnailTrack.classList.remove('is-dragging');

      }


      thumbnailTrack.addEventListener(
        'mouseup',
        stopThumbnailDrag
      );


      thumbnailTrack.addEventListener(
        'mouseleave',
        stopThumbnailDrag
      );


      /*
       * Prevent browser's default image drag.
       *
       * This makes the thumbnail slider feel
       * like a proper draggable carousel.
       */

      thumbnailTrack
        .querySelectorAll('img')
        .forEach(function (image) {

          image.addEventListener(
            'dragstart',
            function (event) {

              event.preventDefault();

            }
          );

        });

    }


    /* =====================================================
       CART ERROR
    ===================================================== */

    function showError(message) {
      if (!errorElement) {
        return;
      }

      errorElement.textContent =
        message || 'Something went wrong. Please try again.';

      errorElement.hidden = false;
    }


    function clearError() {
      if (!errorElement) {
        return;
      }

      errorElement.textContent = '';
      errorElement.hidden = true;
    }


    /* =====================================================
       BUTTON STATE
    ===================================================== */

    function setLoading(isLoading) {
      if (!button) {
        return;
      }

      if (isLoading) {
        button.disabled = true;
        button.classList.add('is-loading');
      } else {
        button.disabled = false;
        button.classList.remove('is-loading');
      }
    }


    /* =====================================================
       UPDATE CART COUNT
       Does NOT open cart drawer.
    ===================================================== */

    function updateCartCount(cart) {
      if (!cart) {
        return;
      }

      const selectors = [
        '[data-cart-count]',
        '[data-cart-count-bubble]',
        '.cart-count-bubble',
        '.cart-count'
      ];

      selectors.forEach(function (selector) {
        const elements = document.querySelectorAll(selector);

        elements.forEach(function (element) {
          element.textContent = cart.item_count;

          if (cart.item_count > 0) {
            element.removeAttribute('hidden');
          }
        });
      });
    }


    /* =====================================================
       ADD TO CART
    ===================================================== */

    if (!button) {
      return;
    }


    if (!variantId) {
      console.error(
        'Recovery Bundle: Variant ID not found.'
      );

      return;
    }


    button.addEventListener('click', async function (event) {
      event.preventDefault();

      if (button.disabled) {
        return;
      }

      clearError();

      setLoading(true);


      try {

        /*
         * IMPORTANT:
         *
         * We DO NOT:
         * - clear the cart
         * - open cart drawer
         * - redirect to checkout
         *
         * We only add the selected variant.
         */

        const response = await fetch(
          window.Shopify.routes.root + 'cart/add.js',
          {
            method: 'POST',

            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },

            body: JSON.stringify({
              items: [
                {
                  id: variantId,
                  quantity: 1
                }
              ]
            })
          }
        );


        const data = await response.json();


        if (!response.ok) {
          throw new Error(
            data.description ||
            data.message ||
            'Unable to add product to cart.'
          );
        }


        /*
         * Get fresh cart data.
         *
         * This does NOT open the cart.
         */

        try {

          const cartResponse = await fetch(
            window.Shopify.routes.root + 'cart.js',
            {
              method: 'GET',

              headers: {
                'Accept': 'application/json'
              }
            }
          );


          if (cartResponse.ok) {
            const cart = await cartResponse.json();

            updateCartCount(cart);
          }

        } catch (cartError) {

          /*
           * Cart was already successfully added.
           * If cart refresh fails, don't show an error
           * because the add-to-cart itself succeeded.
           */

          console.warn(
            'Recovery Bundle: Cart count refresh failed.',
            cartError
          );

        }


        /*
         * SUCCESS
         *
         * Stay on current page.
         */

        // setLoading(false);
        window.location.href = window.Shopify.routes.root + 'checkout';


        /*
         * Small success feedback.
         */

        const originalText =
          button.querySelector(
            '.recovery-bundle__button-text'
          );

        if (originalText) {

          const originalContent =
            originalText.textContent;

          originalText.textContent =
            'ADDED TO CART ✓';

          window.setTimeout(function () {

            originalText.textContent =
              originalContent;

          }, 1600);

        }


      } catch (error) {

        console.error(
          'Recovery Bundle Cart Error:',
          error
        );


        showError(
          error.message ||
          'Something went wrong. Please try again.'
        );


        setLoading(false);
      }

    });

  }


  /* =======================================================
     INITIALIZE
     ======================================================= */

  function initAllRecoveryBundles() {
    const sections = document.querySelectorAll(
      '.recovery-bundle'
    );

    sections.forEach(function (section) {
      initRecoveryBundle(section);
    });
  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initAllRecoveryBundles
    );

  } else {

    initAllRecoveryBundles();

  }


  /* =======================================================
     SHOPIFY THEME EDITOR SUPPORT
     ======================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const section =
        event.target.querySelector(
          '.recovery-bundle'
        );

      if (section) {
        initRecoveryBundle(section);
      }

    }
  );

})();



// (function () {
//   'use strict';

//   function initRecoveryBundle(section) {
//     if (!section || section.dataset.recoveryInitialized === 'true') {
//       return;
//     }

//     section.dataset.recoveryInitialized = 'true';


//     /* =====================================================
//        ELEMENTS
//     ===================================================== */

//     const button = section.querySelector('[data-add-to-cart]');
//     const errorElement = section.querySelector('[data-cart-error]');

//     const mainImage = section.querySelector('[data-main-image]');

//     const thumbnails = section.querySelectorAll('[data-thumbnail]');
//     const previousButton = section.querySelector('[data-thumbnail-prev]');
//     const nextButton = section.querySelector('[data-thumbnail-next]');
//     const thumbnailTrack = section.querySelector('[data-thumbnail-track]');


//     /* =====================================================
//        PRODUCT / VARIANT
//     ===================================================== */

//     const variantId =
//       button &&
//       button.dataset.variantId
//         ? Number(button.dataset.variantId)
//         : null;


//     /* =====================================================
//        THUMBNAIL GALLERY
//     ===================================================== */

//     function changeMainImage(thumbnail) {
//       if (!mainImage || !thumbnail) {
//         return;
//       }

//       const newSrc = thumbnail.dataset.imageSrc;
//       const newSrcset = thumbnail.dataset.imageSrcset;
//       const newAlt = thumbnail.dataset.imageAlt || 'Product image';

//       if (!newSrc) {
//         return;
//       }

//       mainImage.classList.add('is-changing');

//       const preloadImage = new Image();

//       preloadImage.onload = function () {
//         mainImage.src = newSrc;

//         if (newSrcset) {
//           mainImage.srcset = newSrcset;
//         }

//         mainImage.alt = newAlt;

//         window.requestAnimationFrame(function () {
//           mainImage.classList.remove('is-changing');
//         });
//       };

//       preloadImage.onerror = function () {
//         mainImage.classList.remove('is-changing');
//       };

//       preloadImage.src = newSrc;

//       thumbnails.forEach(function (item) {
//         item.classList.remove('is-active');
//       });

//       thumbnail.classList.add('is-active');
//     }


//     thumbnails.forEach(function (thumbnail) {
//       thumbnail.addEventListener('click', function () {
//         changeMainImage(thumbnail);
//       });
//     });


//     /* =====================================================
//        THUMBNAIL ARROWS
//     ===================================================== */

//     function scrollThumbnails(direction) {
//       if (!thumbnailTrack) {
//         return;
//       }

//       const amount = Math.max(
//         thumbnailTrack.clientWidth * 0.75,
//         150
//       );

//       thumbnailTrack.scrollBy({
//         left: direction * amount,
//         behavior: 'smooth'
//       });
//     }


//     if (previousButton) {
//       previousButton.addEventListener('click', function () {
//         scrollThumbnails(-1);
//       });
//     }


//     if (nextButton) {
//       nextButton.addEventListener('click', function () {
//         scrollThumbnails(1);
//       });
//     }


//     /* =====================================================
//        CART ERROR
//     ===================================================== */

//     function showError(message) {
//       if (!errorElement) {
//         return;
//       }

//       errorElement.textContent =
//         message || 'Something went wrong. Please try again.';

//       errorElement.hidden = false;
//     }


//     function clearError() {
//       if (!errorElement) {
//         return;
//       }

//       errorElement.textContent = '';
//       errorElement.hidden = true;
//     }


//     /* =====================================================
//        BUTTON STATE
//     ===================================================== */

//     function setLoading(isLoading) {
//       if (!button) {
//         return;
//       }

//       if (isLoading) {
//         button.disabled = true;
//         button.classList.add('is-loading');
//       } else {
//         button.disabled = false;
//         button.classList.remove('is-loading');
//       }
//     }


//     /* =====================================================
//        UPDATE CART COUNT
//        Does NOT open cart drawer.
//     ===================================================== */

//     function updateCartCount(cart) {
//       if (!cart) {
//         return;
//       }

//       const selectors = [
//         '[data-cart-count]',
//         '[data-cart-count-bubble]',
//         '.cart-count-bubble',
//         '.cart-count'
//       ];

//       selectors.forEach(function (selector) {
//         const elements = document.querySelectorAll(selector);

//         elements.forEach(function (element) {
//           element.textContent = cart.item_count;

//           if (cart.item_count > 0) {
//             element.removeAttribute('hidden');
//           }
//         });
//       });
//     }


//     /* =====================================================
//        ADD TO CART
//        ===================================================== */

//     if (!button) {
//       return;
//     }


//     if (!variantId) {
//       console.error(
//         'Recovery Bundle: Variant ID not found.'
//       );

//       return;
//     }


//     button.addEventListener('click', async function (event) {
//       event.preventDefault();

//       if (button.disabled) {
//         return;
//       }

//       clearError();

//       setLoading(true);


//       try {

//         /*
//          * IMPORTANT:
//          *
//          * We DO NOT:
//          * - clear the cart
//          * - open cart drawer
//          * - redirect to checkout
//          *
//          * We only add the selected variant.
//          */

//         const response = await fetch(
//           window.Shopify.routes.root + 'cart/add.js',
//           {
//             method: 'POST',

//             headers: {
//               'Content-Type': 'application/json',
//               'Accept': 'application/json'
//             },

//             body: JSON.stringify({
//               items: [
//                 {
//                   id: variantId,
//                   quantity: 1
//                 }
//               ]
//             })
//           }
//         );


//         const data = await response.json();


//         if (!response.ok) {
//           throw new Error(
//             data.description ||
//             data.message ||
//             'Unable to add product to cart.'
//           );
//         }


//         /*
//          * Get fresh cart data.
//          *
//          * This does NOT open the cart.
//          */

//         try {

//           const cartResponse = await fetch(
//             window.Shopify.routes.root + 'cart.js',
//             {
//               method: 'GET',

//               headers: {
//                 'Accept': 'application/json'
//               }
//             }
//           );


//           if (cartResponse.ok) {
//             const cart = await cartResponse.json();

//             updateCartCount(cart);


//             /*
//              * Theme compatibility:
//              *
//              * Some Shopify themes listen for
//              * cart update events.
//              *
//              * We intentionally do NOT dispatch
//              * any "open cart" event here.
//              */
//           }

//         } catch (cartError) {

//           /*
//            * Cart was already successfully added.
//            * If cart refresh fails, don't show an error
//            * because the add-to-cart itself succeeded.
//            */

//           console.warn(
//             'Recovery Bundle: Cart count refresh failed.',
//             cartError
//           );

//         }


//         /*
//          * SUCCESS
//          *
//          * Stay on current page.
//          */

//         setLoading(false);


//         /*
//          * Small success feedback.
//          */

//         const originalText =
//           button.querySelector(
//             '.recovery-bundle__button-text'
//           );

//         if (originalText) {

//           const originalContent =
//             originalText.textContent;

//           originalText.textContent =
//             'ADDED TO CART ✓';

//           window.setTimeout(function () {

//             originalText.textContent =
//               originalContent;

//           }, 1600);

//         }


//       } catch (error) {

//         console.error(
//           'Recovery Bundle Cart Error:',
//           error
//         );


//         showError(
//           error.message ||
//           'Something went wrong. Please try again.'
//         );


//         setLoading(false);
//       }

//     });

//   }


//   /* =======================================================
//      INITIALIZE
//   ======================================================= */

//   function initAllRecoveryBundles() {
//     const sections = document.querySelectorAll(
//       '.recovery-bundle'
//     );

//     sections.forEach(function (section) {
//       initRecoveryBundle(section);
//     });
//   }


//   if (
//     document.readyState === 'loading'
//   ) {

//     document.addEventListener(
//       'DOMContentLoaded',
//       initAllRecoveryBundles
//     );

//   } else {

//     initAllRecoveryBundles();

//   }


//   /* =======================================================
//      SHOPIFY THEME EDITOR SUPPORT
//      ======================================================= */

//   document.addEventListener(
//     'shopify:section:load',
//     function (event) {

//       const section =
//         event.target.querySelector(
//           '.recovery-bundle'
//         );

//       if (section) {
//         initRecoveryBundle(section);
//       }

//     }
//   );

// })();